import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Paginator } from 'primeng/paginator';

@Component({
    selector: 'app-custom-paginator',
    templateUrl: './custom-paginator.component.html',
    styleUrls: ['./custom-paginator.component.css'],
    providers: [],
})
export class CustomPaginatorComponent {
    @Input() currentPage:number;
    @Input() totalRecords:number;
    @Input() pageSize:number;
    
    @Output() currentPageChange = new EventEmitter();
    @Output() pageSizeChange = new EventEmitter();
    @Output() onChangePagination = new EventEmitter();

    listRows: number[] = [10, 20, 30];

    onPageChange(event: any) {
        this.currentPageChange.emit(event.page + 1)
        this.onChangePagination.emit()
      }

      onChangeRow(event:any): void {
        this.currentPageChange.emit(1)
        this.pageSizeChange.emit(event.value)
        this.onChangePagination.emit()
    }
}
